import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { USWDSDateInputComponent } from "./date-input.component";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    USWDSDateInputComponent
  ],
  exports: [
    USWDSDateInputComponent
  ]
})
export class USWDSDateInputModule {}
